import { makeObservable, observable } from 'mobx';
import { DataType, IMilestone } from '../types';
import { Item } from './';


export class Milestone extends Item<IMilestone> implements IMilestone {
  approved:    boolean  = null;
  protected constructor(data: IMilestone) {
    // The super constructr takes care of references to the service, validation rules
    // and intialized the base members with mobx decorators
    super(DataType.Milestone, data);

    // Since Mobx cannot track derived class objects automatically,
    // the decorators have to be provided manually 
    makeObservable(this, {
      approved:   observable,
    });

    // Initialize data
    // While the super constructor will call this once,
    // the default values given to members will overwrite this so it has to be called again here. 
    this.fromData(data);
  }

  public static create(data?: IMilestone): Milestone {
    return new Milestone(data || {
      ...Item.create(data).toData(),
      date:     new Date(),
      approved: false,
    });
  }

  protected fromData(data: IMilestone): void {
    super.fromData(data);
    this.approved   = data.approved;
  }

  public toData(): any {
    return {
        ...super.toData(),
        approved: this.approved
    };
  }

  public toPatchData(patch: Partial<IMilestone>): any {
    return {
      ...super.toPatchData(patch),
      approved: "approved" in patch ? patch.approved : undefined
    };
  }

  public validate = async (asBoolean?: boolean): Promise<any> => {
    let parentInvalids = await super.validate();
    if(this.isNew) return [];
    if(this.approved)  return [];

    // type this object, make generic for items and let each items contribute to list of required fields
    const obj: any = {
      date: this.date,
    };
    
    const itemInvalids = Object.keys(obj).filter((k) => {
      return !obj[k];
    });

    const invalids = [...parentInvalids, ...itemInvalids]

    return asBoolean ? invalids.length : invalids;
  }
}

export namespace Milestone {
  export enum Status {
    New = "new",
  }
}